export function getAssetHost(): $TSFixMe {
  return ASSET_HOST;
}
